/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_Secured_Site_HelpInputs */

const en_cad_field_secured_site_help = /** @type {(inputs: Cad_Field_Secured_Site_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If yes, we'll also log access-not-granted.`)
};

const ja_cad_field_secured_site_help = /** @type {(inputs: Cad_Field_Secured_Site_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「はい」の場合、アクセス拒否も記録します。`)
};

const fr_cad_field_secured_site_help = /** @type {(inputs: Cad_Field_Secured_Site_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si oui, nous enregistrons aussi un refus d'accès.`)
};

const de_cad_field_secured_site_help = /** @type {(inputs: Cad_Field_Secured_Site_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falls ja, erfassen wir zusätzlich „Zugang verweigert“.`)
};

/**
* | output |
* | --- |
* | "If yes, we'll also log access-not-granted." |
*
* @param {Cad_Field_Secured_Site_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_secured_site_help = /** @type {((inputs?: Cad_Field_Secured_Site_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_Secured_Site_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_secured_site_help(inputs)
	if (locale === "ja") return ja_cad_field_secured_site_help(inputs)
	if (locale === "fr") return fr_cad_field_secured_site_help(inputs)
	return de_cad_field_secured_site_help(inputs)
});